"use client";

import { ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThePresence() {
  const sectionReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const contentReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4811" id="the-presence" ref={sectionReveal.ref} className="relative min-h-screen w-full overflow-hidden bg-[#1a1a1a] text-foreground">
      

      <div className="relative z-10 mx-auto flex min-h-screen max-w-[1440px] flex-col justify-center pl-10 pt-32 pb-16 sm:pl-16 lg:pl-24">
        <div ref={contentReveal.ref} className={`max-w-[52.5rem] transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${contentReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="mb-16">
            <span className="font-sans uppercase tracking-[0.4em] text-accent !text-base !font-bold"><span className="!font-default">Creative Marketing Consultant</span></span>
          </div>

          <h1 className="font-sans text-[clamp(3rem,8vw,8rem)] font-bold leading-[0.9] tracking-[0.15em] text-foreground uppercase">
            <span className="block">You built something real.</span>
            <span className="mt-2 block italic text-[clamp(1.2rem,2.5vw,1.8rem)] font-medium normal-case tracking-normal text-foreground/70">
              Does the internet know it exists?
            </span>
          </h1>

          <div className="mt-12 max-w-[32.5rem]">
            <p className="font-sans text-lg leading-[1.6] tracking-[0.01em] text-foreground/80 lg:text-xl"><span className="!font-default">Get found. Get heard. Get trusted. We bridge the gap between exceptional craft and digital authority.</span></p>

            <div className="mt-16 flex flex-wrap items-center gap-6">
              <Button asChild className="h-14 rounded-lg bg-accent px-10 font-sans text-xs font-bold uppercase tracking-widest text-accent-foreground transition-all hover:opacity-90">
                <Link to="/ResultsPage">
                  Discover Your 5ONDER Score
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="h-14 rounded-lg border-foreground/20 bg-transparent px-10 font-sans text-xs font-bold uppercase tracking-widest text-foreground transition-all hover:bg-foreground/5">
                <Link to="/ServicesPage">
                  View Services
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-6 z-20 flex flex-col items-start gap-4 sm:left-10 lg:left-16">
        
        
      </div>

      <style>{`
        @keyframes scroll-line {
          0% { transform: translateY(-100%); opacity: 0; }
          50% { transform: translateY(0%); opacity: 1; }
          100% { transform: translateY(100%); opacity: 0; }
        }
      `}</style>
    </section>;
}